import Vue from "vue";
import PreviewRubricView from "@/views/preview_rubric_view.vue";

export const openRubricPreview = (rubric) => {
  Vue.prototype.$openForm("rubric-preview", {
    forceComponent: PreviewRubricView,
    isModal: true,
    modalProps: {
      size: "fullscreen",
      hideTitle: true,
      hideFooter: true,
      modalClass: "eg-rubric-modal",
    },
    props: {
      initialRubricId: rubric.id,
      withHeader: false,
    },
    callback: () => {},
  });
};
